/**
 * A localStorage-unique prefix for all keys stored in StorageService
 */
export const STORAGE_PREFIX = 'com.bssnet.guardian'
/**
 * A wrapper for localStorage which handles marshalling & prefixing keys to make them unique
 */
export class StorageService {
    static get(key) {
        try {
            return JSON.parse(localStorage.getItem(`${STORAGE_PREFIX}.${key}`))
        } catch (err) {
            return null
        }
    }

    static set(key, value) {
        localStorage.setItem(`${STORAGE_PREFIX}.${key}`, JSON.stringify(value))
    }

    static clearData() {
        let arr = []
        // Iterate over localStorage and insert the keys that meet the condition into arr
        for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).substring(0, STORAGE_PREFIX.length) === STORAGE_PREFIX) {
                if (
                    localStorage
                        .key(i)
                        .substring(STORAGE_PREFIX.length + 1, localStorage.key(i).length) !==
                    'dashboardLayout'
                ) {
                    arr.push(localStorage.key(i))
                }
            }
        }

        // Iterate over arr and remove the items by key
        for (let i = 0; i < arr.length; i++) {
            localStorage.removeItem(arr[i])
        }
    }
}
